import { useEffect, useRef, useState } from "react";

interface ToastItem {
  id: number;
  message: string;
  ok?: boolean;
}

let _enqueue: ((msg: string, ok?: boolean) => void) | null = null;

export function toast(message: string, ok?: boolean) {
  _enqueue?.(message, ok);
}

export function ToastProvider() {
  const [items, setItems] = useState<ToastItem[]>([]);
  const counterRef = useRef(0);

  useEffect(() => {
    _enqueue = (message, ok) => {
      const id = ++counterRef.current;
      setItems((prev) => [...prev, { id, message, ok }]);
      setTimeout(() => {
        setItems((prev) => prev.filter((i) => i.id !== id));
      }, 3200);
    };
    return () => { _enqueue = null; };
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="toast-wrap">
      {items.map((item) => (
        <div key={item.id} className={`toast show${item.ok ? " ok" : ""}`}>
          <span className="ic">
            {item.ok ? (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            ) : (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" />
              </svg>
            )}
          </span>
          {item.message}
        </div>
      ))}
    </div>
  );
}
